import { render, staticRenderFns } from "./AnnualReturnsTab.vue?vue&type=template&id=cccbfd56&scoped=true&"
import script from "./AnnualReturnsTab.vue?vue&type=script&lang=js&"
export * from "./AnnualReturnsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cccbfd56",
  null
  
)

export default component.exports